import { render, staticRenderFns } from "./build5.vue?vue&type=template&id=ad2c8fd2&scoped=true&"
import script from "./build5.vue?vue&type=script&lang=js&"
export * from "./build5.vue?vue&type=script&lang=js&"
import style0 from "./build5.vue?vue&type=style&index=0&id=ad2c8fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2c8fd2",
  null
  
)

export default component.exports